import { Outlet } from "react-router-dom";

import HeaderContainer from "../../containers/HeaderContainer";

import style from "./HeaderLayout.module.css";

export const HeaderLayout: React.FC = () => {
  return (
    <div className={style.container}>
      <HeaderContainer />
      <div className={style.headerLayout}>
        <Outlet />
      </div>
    </div>
  );
};
